export class GetGriStandardsAction {
  static readonly type = '[InfoService] Get Gri Standards';
}
